$(function(){

});


/**
 * Получение токена для нового посетителя
 */
function getVisitorToken(callback)
{
	var URI = "/api/visitor/new";
	var data = {};
	var headers = {};
	var onload_callback = function(a) {
		Cookies.set("visitor_token", a.visitor_token);
		if (callback) {
			callback(a);
		}
	}
	var onerror_callback = function(a) {
		console.log('Error')
		console.log(a)
	}
	xhr_request(URI, headers, data, 5000, onload_callback, onerror_callback);
}


/**
 * Получение посетителя по токену
 */
visitor = null;
function getVisitor(callback)
{
	var visitor_token = Cookies.get("visitor_token");
	console.log('getVisitor '+visitor_token)
	var URI = "/api/visitor/get";
	var data = {visitor_token:visitor_token};
	var headers = {};
	var onload_callback = function(a) {
		visitor = a.visitor;
		if (callback) {
			callback(a);
		}
	}
	var onerror_callback = function(a) {
		Cookies.set("visitor_token", null);
		console.log('visitor token deleted!');
	}
	xhr_request(URI, headers, data, 5000, onload_callback, onerror_callback);
}


/**
 * Добавиление разметки виджета корзины
 */
function addCartWidget()
{
	var c = '<div id="cart_wrapper">';
		c+= '<div id="cart_widget"><i class="fa fa-shopping-cart"></i></div>';
		c+= '<div id="cart_widget_container" hidden>';
		c+= '<div class="text-center" style="padding:5px;"><a href="/cart" class="btn btn-block btn-sm btn-outline-orange">Перейти в корзину</a></div>';
		c+= '<div id="cart_empty" class="text-center">Корзина пуста</div>';
		c+= '</div>';
		c+= '</div>';
	var cart = $(c);
	$("#cart_widget", cart).bind('click', function(){
		var is_hidden = $("#cart_widget_container").prop('hidden');
		if (is_hidden == true) {
			$("#cart_widget_container").prop('hidden', false);
		} else {
			$("#cart_widget_container").prop('hidden', true);
		}
	});
	$('body').append(cart);
}


/**
 * Загрузка виджета корзины и наполнение данными
 */
function loadCart(cart_data)
{
	if (cart_data.length > 0) {
		$("#cart_widget_container").html("<div class='text-center' style='padding:5px;'><a href='/cart' class='btn btn-block btn-sm btn-outline-orange'>Перейти в корзину</a></div><div class='clear' style='height:10px;'></div><div id='cart_summary'></div>");
	}
	summary = 0;
	$.each(cart_data, function(i, item){
		summary+= (item.price * item.count);
		
		var line_price = (item.price * item.count);
		var line_price = numeral(line_price).format('0,0[.]00');

		$("#cart_widget_container").append("<div class='cart_line'>" + item.name + " &times " + item.count + "<div class='float-right'>" + line_price + " ₽</div><div class='clearfix'></div></div>");
	});
	var summary_text = numeral(summary).format('0,0[.]00');
	$("#cart_summary").html("Итого: " + summary_text + " ₽");
}


/**
 * Добавление товара в корзину
 */
function add_to_cart(item_id, callback)
{
	var visitor_token = Cookies.get("visitor_token");
	var URI = "/api/visitor/add_to_cart";
	var data = {visitor_token:visitor_token, item_id:item_id};
	var headers = {};
	var onload_callback = function(a) {
		toastr.info("Добавлено в корзину")
		loadCart(a.cart);
		if (callback) {
			callback(a);
		}
	}
	var onerror_callback = function(a) {
		if (a.hasOwnProperty('is_type_error') && a.is_type_error) {
			toastr.info(a.description);
		} else {
			toastr.info("Ошибка добавления в корзину");
			Cookies.set("visitor_token", null);
		}
	}
	xhr_request(URI, headers, data, 5000, onload_callback, onerror_callback);	
}


/**
 * Анимирование перелета товара в корзину
 */
function animate_cart_fly(cart, imgtodrag)
{
	if (imgtodrag) {
		var imgclone = imgtodrag.clone()
			.offset({
			top: imgtodrag.offset().top,
			left: imgtodrag.offset().left
		})
		.css({
			'opacity': '0.5',
			'position': 'absolute',
			'height': '150px',
			'width': '150px',
			'z-index': '100'
		})
		.appendTo($('body'))
		.animate({
			'top': cart.offset().top-90,
			'left': cart.offset().left+20,
			'width': 5,
			'height': 5
		}, 600);
		imgclone.animate({
			'width': 0,
			'height': 0
		}, function () {
			$(this).detach()
		});
	}
}